import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorGreen = createSvgIcon(
  <circle cx="10" cy="10" fill="#1F8B4D" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorGreen',
);
